import { store } from '../App.js'

export const getServerUrl = () => {
    const currentUser = store.getState().loginReducer.currentUser
    if (currentUser?.region?.toLowerCase() === 'eu') {
        return process.env.REACT_APP_SERVER_URL_EU
    }
    return process.env.REACT_APP_SERVER_URL
}